import * as t from '../types';
import {GetGrades} from '../../services'


export const getGrades = (value) => async (dispatch) => {
    dispatch({
        type: t.GET_GRADES_REQUEST
    });

    return await GetGrades(value)

        .then((data) => {
            dispatch({
                type: t.GET_GRADES_SUCCESS,
                payload: data
            });
        })
        .catch((err) => {
            dispatch({
                type: t.GET_GRADES_FAILED,
                payload: err.response
            });
        });
};
